/* eslint-disable css-modules/no-unused-class  */
import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { translate } from 'translations';
import { Avatar, Icon } from 'learning-panel-components';
import { getColorByScore } from 'utils';
import { userQuestion } from '../previewPage/previewPage';
import styles from './topBar.module.scss';

const TopBar: FC<TopBarProps> = (props: TopBarProps) => {
    const {
        name,
        vulName,
        userQuestions,
        userNickname,
        userScore,
        potentialScore,
        onNavigateToNextQuestion,
        onNavigateToPreviousQuestion,
        questionNumber,
        totalQuestions,
        userAvatar,
        onNavigateToQuestion
    } = props;

    const [questionsColors, setQuestionsColors] = useState<string[]>([]);
    const [questionsColorsGradient, setQuestionsColorsGradient] = useState<string>('');
    const navigate = useNavigate();

    useEffect(() => {
        const colors: string[] = [];
        userQuestions.map(question => colors.push(getColorByScore(question.percentages)));
        setQuestionsColors(colors);
        setQuestionsColorsGradient(
            `linear-gradient(90deg, ${colors[0]} 0%, ${colors[1]} 24.11%, ${colors[2]} 47.38%, ${colors[3]} 71.96%, ${colors[4]} 100%)`
        );
    }, [userQuestions]);

    return (
        <div className={styles['lab-top-bar']}>
            <div className={styles.left}>
                <img
                    src={`${process.env.PUBLIC_URL}/images/cxSmallLogo.svg`}
                    className={styles.logo}
                    alt="Codebashing Logo"
                />
                <div className={styles.data}>
                    <div className={styles.back} onClick={() => navigate(-1)}>
                        <Icon name="back" />
                        {translate('ExitGame')}
                    </div>
                    <hr />
                    <div className={styles['vul-name']}>{name}</div>
                    {vulName && <hr />}
                    {vulName && <div className={styles['vul-name']}>{vulName}</div>}
                </div>
            </div>
            <div className={styles.right}>
                <div className={styles['question-number']}>
                    <span>{translate('Question')}</span>
                    <span className={styles['current-question']}>{props.questionNumber}</span>
                    <span className={styles['total-question']}>{`/${props.totalQuestions}`}</span>
                </div>
                <div className={styles['questions-statuses']}>
                    <div className={styles['questions-statuses-base']} style={{ background: questionsColorsGradient }}>
                        <div className={styles['questions-statuses-inner-base']}></div>
                    </div>
                    <div className={styles['questions-wrapper']}>
                        {userQuestions.map((question, index) =>
                            index + 1 === questionNumber ? (
                                <div className={styles['avatar-wrapper']} key={index}>
                                    <Avatar name={userNickname} avatarSrc={userAvatar} size="3.3125rem" />
                                    {question.percentages !== undefined && (
                                        <div
                                            key={index}
                                            className={styles.question}
                                            style={
                                                {
                                                    '--color': questionsColors[index]
                                                } as any
                                            }
                                        >
                                            {`${question.percentages}%`}
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div
                                    onClick={onNavigateToQuestion(index + 1)}
                                    key={index}
                                    className={styles['question-status']}
                                    style={
                                        {
                                            '--color': questionsColors[index]
                                        } as any
                                    }
                                >
                                    {question.percentages !== undefined ? (
                                        `${question.percentages}%`
                                    ) : (
                                        <Icon name="questionMarkAdmin" />
                                    )}
                                </div>
                            )
                        )}
                    </div>
                </div>
                <div className={styles['navigate-buttons']}>
                    <Icon
                        name="chevronLeft"
                        onClick={() => (questionNumber === 1 ? undefined : onNavigateToPreviousQuestion())}
                        className={questionNumber === 1 ? styles.disabled : styles['navigate-button']}
                    />
                </div>
                <div className={styles['navigate-buttons']}>
                    <Icon
                        name="chevronRight"
                        onClick={() => (questionNumber === totalQuestions ? undefined : onNavigateToNextQuestion())}
                        className={questionNumber === totalQuestions ? styles.disabled : styles['navigate-button']}
                    />
                </div>
                <hr />
                <div className={styles.score}>
                    <Icon name="devCoin" className={styles['dev-coin']} />
                    <div className={styles.scores}>
                        <div className={styles['user-score']}>{userScore}</div>
                        <div className={styles['potential-score']}>{potentialScore}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

interface TopBarProps {
    name: string;
    vulName: string;
    questionNumber: number;
    totalQuestions: number;
    onNavigateToNextQuestion: Function;
    onNavigateToPreviousQuestion: Function;
    potentialScore: number;
    userScore: number;
    userQuestions: userQuestion[];
    userAvatar?: string;
    userNickname: string;
    onNavigateToQuestion: Function;
}

export default TopBar;
